import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "axios"
import { getStorageToken } from "../utils/storageToken"

const sendEntityInfo = createAsyncThunk('ENTITY/SEND', async (payload, thunkAPI) => {
    try {
        const token = getStorageToken()
        const API_URL = `${process.env.REACT_APP_HDMS_API_URI}/api/v1/entity/meta`
        const response = await axios.post(
            API_URL,
            {
                entityID: payload.entityID,
                siren: payload.siren,
                address: payload.address,
                team: payload.team,
                profilePictureUrl: payload.profilePictureUrl,
                needs: payload.needs
            },
            {headers:{
                Authorization: 'Bearer ' + token
            }}
        )
        return thunkAPI.fulfillWithValue(response.data)
    } catch (error) {
        console.error(error)
        return thunkAPI.rejectWithValue(error)
    }
})

const initialState = {
    entityID: '',
    name: '',
    category: '',
    siren: '',
    address: '',
    teamNb: '',
    interest: {
        datagen: false,
        dataStudio: false,
        dataManagement: false
    },
    description: '',
    isLoading: false,
    error: undefined,
    success: false
}

export const onboardingSlice = createSlice({
    name: 'Onboarding',
    initialState,
    reducers: {
        setEntityID: (state, action) => {
            state.entityID = action.entityID
        },
        setName: (state, action) => {
            state.name = action.payload
        },
        setCategory: (state, action) => {
            state.category = action.payload
        },
        setSiren: (state, action) => {
            state.siren = action.payload
        },
        setAddress: (state, action) => {
            state.address = action.payload
        },
        setTeamNb: (state, action) => {
            state.teamNb = action.payload
        },
        setInterestDatagen: (state, action) => {
            state.interest.datagen = action.payload
        },
        setInterestDataStudio: (state, action) => {
            state.interest.dataStudio = action.payload
        },
        setInterestDataManagement: (state, action) => {
            state.interest.dataManagement = action.payload
        },
        setDescription: (state, action) => {
            state.description = action.payload
        }
    },
    extraReducers(builder) {
        builder.addCase(sendEntityInfo.pending, state => {
            state.isLoading = true
        })
        builder.addCase(sendEntityInfo.rejected, (state, action) => {
            state.error = action.error
            state.success = false
            state.isLoading = false
        })
        builder.addCase(sendEntityInfo.fulfilled, (state) => {
            state.isLoading = false
            state.success = true
        })
    }
})

export const {
    setEntityID,
    setName,
    setCategory,
    setSiren,
    setAddress,
    setTeamNb,
    setInterestDatagen,
    setInterestDataStudio,
    setInterestDataManagement,
    setDescription
} = onboardingSlice.actions
export { sendEntityInfo }
export default onboardingSlice.reducer
